var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarToday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 2.50016H15.8334V1.66683C15.8334 1.2085 15.4584 0.833496 15.0001 0.833496C14.5417 0.833496 14.1667 1.2085 14.1667 1.66683V2.50016H5.83342V1.66683C5.83342 1.2085 5.45841 0.833496 5.00008 0.833496C4.54175 0.833496 4.16675 1.2085 4.16675 1.66683V2.50016H3.33341C2.41675 2.50016 1.66675 3.25016 1.66675 4.16683V17.5002C1.66675 18.4168 2.41675 19.1668 3.33341 19.1668H16.6667C17.5834 19.1668 18.3334 18.4168 18.3334 17.5002V4.16683C18.3334 3.25016 17.5834 2.50016 16.6667 2.50016ZM15.8334 17.5002H4.16675C3.70841 17.5002 3.33341 17.1252 3.33341 16.6668V6.66683H16.6667V16.6668C16.6667 17.1252 16.2917 17.5002 15.8334 17.5002Z",
    fill: "#A3ADC0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar_today.4d3d898c55f05b606fdaa5d1d6ecb82a.svg";
export { ForwardRef as ReactComponent };